import React, { FC, KeyboardEvent, memo, MouseEvent, MouseEventHandler, useContext } from 'react'
import { ThemeContext } from 'styled-components'

import {
    MobileSearchBarContainer,
    Col,
    Input,
    InputsContainer,
    Row,
    DatePickerIcon,
    LocationPickerIcon,
    GuestPickerIcon,
} from './styles'
import { useTranslation } from '../../../../../hooks/locale'
import ModalFooter from '../../../../common/modal/modal-footer'
import { SubmitButton } from '../styles'
import { InputError } from '../../../../common/input-styles'

interface Props {
    onLocationPickerOpen: () => void
    onDatePickerOpen: () => void
    onGuestPickerOpen: () => void
    locationPickerLabel: string
    datePickerLabel: string
    guestPickerLabel: string
    locationPickerError?: string
    onSubmit: MouseEventHandler<HTMLButtonElement>
    showMainSearchBar?: boolean
}

const MobileSearchBar: FC<Props> = ({
    onLocationPickerOpen,
    onDatePickerOpen,
    onGuestPickerOpen,
    locationPickerLabel,
    datePickerLabel,
    guestPickerLabel,
    locationPickerError,
    onSubmit,
    showMainSearchBar = false,
}) => {
    const { t } = useTranslation()
    const theme = useContext(ThemeContext)

    return (
        <MobileSearchBarContainer>
            <InputsContainer>
                <Row>
                    <Col hasError={!!locationPickerError} onClick={onLocationPickerOpen} role="button">
                        <LocationPickerIcon alt={t('mapIconText')} />
                        <Input value={locationPickerLabel} />
                        {!!locationPickerError && <InputError>{locationPickerError}</InputError>}
                    </Col>
                </Row>
                <Row>
                    <Col onClick={onDatePickerOpen} role="button">
                        <DatePickerIcon alt={t('calendarIconText')} />
                        <Input value={datePickerLabel} />
                    </Col>
                </Row>
                <Row>
                    <Col onClick={onGuestPickerOpen} role="button">
                        <GuestPickerIcon alt={t('guestIconText')} />
                        <Input value={guestPickerLabel} />
                    </Col>
                </Row>
            </InputsContainer>
            <ModalFooter padding={theme.spacing.xSmall}>
                <SubmitButton showMainSearchBar={showMainSearchBar} onClick={onSubmit}>
                    {t('searchButtonText')}
                </SubmitButton>
            </ModalFooter>
        </MobileSearchBarContainer>
    )
}

export default memo(MobileSearchBar)
